export function AdminShowPeopleInfo() {
  return (
    <div>
      <h1> This the data from the people...</h1>
    </div>
  );
}
